import { apiFetch } from '../lib/apiFetch';

export interface WebhookLogSummary {
  id: string;
  received_at: string;
  source: string;
  event_type: string | null;
  http_method: string;
  ip_address: string | null;
  payload_size: number | null;
  status: string;
  bronze_table: string | null;
  record_pk: string | null;
  dedup_result: string | null;
  processing_ms: number | null;
  error_message: string | null;
  run_id: string | null;
  completed_at: string | null;
}

export interface WebhookLogDetail extends WebhookLogSummary {
  request_headers: Record<string, string> | null;
  payload: Record<string, unknown>;
}

export interface WebhookLogStats {
  totalToday: number;
  successToday: number;
  errorsToday: number;
  lastReceived: string | null;
  avgProcessingMs: number;
  totalAllTime: number;
}

export interface FetchWebhookLogsParams {
  eventType?: string;
  status?: string;
  dateFrom?: string;
  dateTo?: string;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

export interface WebhookLogsResponse {
  logs: WebhookLogSummary[];
  pagination: {
    limit: number;
    offset: number;
    total: number;
  };
}

export async function fetchWebhookLogs(params: FetchWebhookLogsParams = {}): Promise<WebhookLogsResponse> {
  const qs = new URLSearchParams();
  if (params.eventType) qs.set('eventType', params.eventType);
  if (params.status) qs.set('status', params.status);
  if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
  if (params.dateTo) qs.set('dateTo', params.dateTo);
  if (params.sort) qs.set('sort', params.sort);
  if (params.sortDir) qs.set('sortDir', params.sortDir);
  if (params.limit) qs.set('limit', params.limit.toString());
  if (params.offset !== undefined) qs.set('offset', params.offset.toString());

  const res = await apiFetch(`/api/v1/webhook-logs?${qs.toString()}`);
  if (!res.ok) {
    throw new Error(`Failed to fetch webhook logs: ${res.status}`);
  }
  return res.json();
}

export async function fetchWebhookLogStats(): Promise<WebhookLogStats> {
  const res = await apiFetch('/api/v1/webhook-logs/stats');
  if (!res.ok) {
    throw new Error(`Failed to fetch webhook log stats: ${res.status}`);
  }
  return res.json();
}

export async function fetchWebhookLogDetail(id: string): Promise<WebhookLogDetail> {
  const res = await apiFetch(`/api/v1/webhook-logs/${id}`);
  if (!res.ok) {
    throw new Error(`Failed to fetch webhook log detail: ${res.status}`);
  }
  const data = await res.json();
  return data.log;
}
